import React, { useState, useMemo } from "react";
import { toast } from "react-toastify";

import { sigin } from "services/auth.service";

const AppContext = React.createContext();

export function AppProvider(props) {
  const [user, setUser] = useState(null);
  const [sidebarShow, setSidebarShow] = useState("responsive");
  const [loading, setLoading] = useState(false);

  const login = async (values) => {
    setLoading(true);
    try {
      const userLogin = await sigin(values);
      setUser(userLogin);
      localStorage.setItem("utk", userLogin.token);
      setLoading(false);
      return userLogin;
    } catch (err) {
      setLoading(false);
    }
  };

  const signup = async (values) => {
    await signup(values);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("utk");
  };

  const showNotification = (message, type) => {
    const props = {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    };

    if (type === "success") {
      toast.success(message, props);
    } else if (type === "info") {
      toast.info(message, props);
    } else if (type === "error") {
      toast.error(message, props);
    } else {
      toast(message, props);
    }
  };

  // eslint-disable-next-line
  const value = useMemo(() => {
    return {
      user,
      loading,
      login,
      logout,
      signup,
      sidebarShow,
      setSidebarShow,
      showNotification,
    };
  });

  return <AppContext.Provider value={value} {...props} />;
}

export function useApp() {
  const context = React.useContext(AppContext);
  if (!context) {
    throw new Error("UseUser debe estar dentro del proveedor UserContext");
  }
  return context;
}
